import React from 'react'

import { Card, CardContent } from '@/components/ui/card'
import LoadingWidget from '@/components/widgets/LoadingWidget'

const LoadingCard: React.FC = () => (
  <Card>
    <CardContent>
      <LoadingWidget />
    </CardContent>
  </Card>
)

export default LoadingCard
